import { useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import { FinancedAmountStore, useGetEligiblePlans } from '@servicetitan/financing-plans-shared';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';

const DEBOUNCE_MS = 500;

export const useAffirmPaymentOptions = () => {
    const { financedAmount } = FinancedAmountStore.useStore();
    const { setupData } = SetupDataStore.useStore();
    const [localAmount, setLocalAmount] = useState(financedAmount);
    const [queryAmount, setQueryAmount] = useState(financedAmount);

    const debouncedSetQueryAmount = useMemo(
        () => debounce((amount: number) => setQueryAmount(amount), DEBOUNCE_MS),
        [],
    );

    useEffect(() => {
        debouncedSetQueryAmount.cancel();
        setLocalAmount(financedAmount);
        setQueryAmount(financedAmount);
    }, [financedAmount, debouncedSetQueryAmount]);

    useEffect(() => () => debouncedSetQueryAmount.cancel(), [debouncedSetQueryAmount]);

    const handleAmountChange = (amount: number) => {
        setLocalAmount(amount);
        debouncedSetQueryAmount(amount);
    };

    const { data, isLoading } = useGetEligiblePlans({
        providerName: 'Affirm',
        tenantId: setupData?.tenantId ?? null,
        buId: setupData?.buId ?? null,
        amount: queryAmount,
        allPlans: true,
        state: setupData?.state,
        useAdditionalPromotions: true,
        planList: null,
        paymentFrequency: null,
        merchantId: 'all',
    });

    return {
        localAmount,
        handleAmountChange,
        plans: data?.data ?? [],
        isLoading,
    };
};
